import { createTheme } from "@mui/material/styles";
import grey from "@mui/material/colors/grey";

import { arAR } from "./locals";

import { green } from "../constants/colors";

// custom theme
const theme = createTheme(
  {
    direction: "rtl",
    shadows: ["none"],
    palette: {
      secondary: {
        dark: grey,
        light: "#f9f3f3",
        main: "#b9b4b4",
      },
      primary: {
        dark: "#2e78a3",
        main: green,
        light: "#bad4e3",
      },
      error: {
        main: "#B00020",
      },
      white: {
        main: "#ffffff",
      },
    },
    typography: {
      color: "#525252",
      fontFamily: ["san", "Tajawal", "sans-serif"].join(","),
    },
    overrides: {
      MuiInput: {
        input: {
          "&::placeholder": {
            color: "#b9b4b4",
            fontSize: "14px",
          },
        },
      },
    },
  },
  arAR,
);

export default theme;
